
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { startOfMonth, endOfMonth, format } from "date-fns";

export interface Expense {
  id: string;
  amount: number;
  description: string | null;
  expense_date: string;
  expense_categories: {
    name: string;
  };
}

export const useHouseExpenses = (houseId: string, month: Date | null) => {
  const { toast } = useToast();
  
  const startDate = month ? startOfMonth(month) : null;
  const endDate = month ? endOfMonth(month) : null;

  const formattedStartDate = startDate ? format(startDate, 'yyyy-MM-dd') : null;
  const formattedEndDate = endDate ? format(endDate, 'yyyy-MM-dd') : null;

  return useQuery({
    queryKey: ['house-expenses', houseId, formattedStartDate, formattedEndDate],
    queryFn: async () => {
      if (!houseId || !formattedStartDate || !formattedEndDate) {
        return [];
      }

      const query = supabase
        .from('expenses')
        .select(`
          id,
          amount,
          description,
          expense_date,
          expense_categories (
            name
          )
        `)
        .eq('entity_id', houseId)
        .eq('entity_type', 'house')
        .gte('expense_date', formattedStartDate)
        .lte('expense_date', formattedEndDate);

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching house expenses:', error);
        toast({
          title: "Error",
          description: "No se pudieron cargar los gastos",
          variant: "destructive",
        });
        return [];
      }

      return data;
    },
    enabled: !!houseId && !!formattedStartDate && !!formattedEndDate,
  });
};
